"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LobbyRaceGenderWindow;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _LobbyRaceGenderWindowModule = _interopRequireDefault(require("./LobbyRaceGenderWindow.module.scss"));

var _Button = _interopRequireDefault(require("../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../inputElements/Button/EButtonType"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function LobbyRaceGenderWindow(_ref) {
  var onChangeRace = _ref.onChangeRace,
      onChangeGender = _ref.onChangeGender,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      selectedRace = _useState2[0],
      setSelectedRace = _useState2[1];

  var _useState3 = (0, _react.useState)("female"),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedGender = _useState4[0],
      setSelecteGender = _useState4[1];

  var selectRace = (0, _react.useCallback)(function (raceId) {
    setSelectedRace(raceId);
    if (onChangeRace) onChangeRace(raceId);
    /*
      TODO
      $('#audio_figure').attr('src','audio/sounds/character/'+current_race+'_'+gender_short+'_shout03.wav');
      $('#audio_figure')[0].play();
      classes_update(current_race); // update classes
      shape_reset(); // reset shapes
      status_reset(current_race); // reset status
      description_change(current_race); // change description
      // disable button to continue
      $('#create_btn_next').removeAttr('onclick');
      // slide in windows if first choose
      if($('#window_classes').css("display") == 'none') {
          classes_slide_in();
          shapes_slide_in();
          status_slide_in();
      }
      */
  }, [onChangeRace]);
  var changeGender = (0, _react.useCallback)(function (gender) {
    setSelecteGender(gender);
    if (onChangeGender) onChangeGender(gender);
    /*
      TODO
      $('#audio_figure').attr('src','audio/sounds/character/'+current_race+'_'+gender_short+'_shout03.wav');
    $('#audio_figure')[0].play();
      */
  }, [onChangeGender]);
  var renderRaceEntry = (0, _react.useCallback)( // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  function (raceId, label) {
    var isDisabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: (0, _classnames.default)(_LobbyRaceGenderWindowModule.default.raceBtn, _LobbyRaceGenderWindowModule.default[raceId], selectedRace === raceId && _LobbyRaceGenderWindowModule.default.isSelected, isDisabled && _LobbyRaceGenderWindowModule.default.isDisabled),
      type: _EButtonType.default.RACE_SELECT,
      onClick: function onClick() {
        return selectRace(raceId);
      },
      isDisabled: isDisabled || selectedRace === raceId
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _LobbyRaceGenderWindowModule.default.btnContent
    }, label));
  }, [selectRace, selectedRace]); // TODO: i18n labels from data

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_LobbyRaceGenderWindowModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _LobbyRaceGenderWindowModule.default.races
  }, renderRaceEntry("human", "Human", true), renderRaceEntry("barbarian", "Barbarian"), renderRaceEntry("highelf", "High-Elf"), renderRaceEntry("woodelf", "Wood-Elf"), renderRaceEntry("dwarf", "Dwarf", true), renderRaceEntry("gnome", "Gnome", true)), /*#__PURE__*/_react.default.createElement("div", {
    className: _LobbyRaceGenderWindowModule.default.genders
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.GENDER_MALE,
    className: _LobbyRaceGenderWindowModule.default.male,
    onClick: function onClick() {
      return changeGender("male");
    },
    isDisabled: selectedGender === "male"
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.GENDER_FEMALE,
    className: _LobbyRaceGenderWindowModule.default.female,
    onClick: function onClick() {
      return changeGender("female");
    },
    isDisabled: selectedGender === "female"
  })));
}